import { OFFSET_SCROLL } from '../utils/constants';
import smoothScroll from '../utils/smoothScroll';

const contentLinks = document.querySelectorAll('.content a[href^="#"]');

// add some offset, so the element is visible when scrolled to
const addClickEvent = (link, offset = OFFSET_SCROLL) => {
  // exclude inpage navigation links, bc they have own logic (& jQuery still :/)
  if (!link.classList.contains('jumpmark-menu__link')) {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const linkedContentTop = document.body
        .querySelector(`${link.hash}`)
        ?.getBoundingClientRect().top;
      const scrollTo = Math.round(linkedContentTop) + window.scrollY;
      // '0' is falsy, so it needs to be included as good to proceed
      if (scrollTo >= 0) {
        smoothScroll(scrollTo - offset);
      }
    });
  }
};

(() => {
  if (contentLinks.length) {
    contentLinks.forEach((link) => addClickEvent(link));
  }
})();
